/**
 * USER-POPULATIONS
 * Populations d'un utilisateur (périmètre du tableau de bord)
 */

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCaretRight } from "@fortawesome/free-solid-svg-icons"
import { sortBy } from "lodash"

interface Population {
  filterName?: string | null
  name: string
}

interface OwnProps {
  populations: Population[]
  emptyLabel?: string | null //Affiché sans population : tout le périmètre (nom du compte)
  isOrdered?: boolean //Garde l'ordre reçu au lieu de trier par nom
  onClick?: Function
}

export default function UserPopulations(props: OwnProps) {
  const className = props.onClick ? "_hover grey-t" : "grey-t"
  const click = () => props.onClick?.()

  if (props.populations.length === 0) {
    return props.emptyLabel ? (
      <div className={className} onClick={click}>
        {props.emptyLabel}
      </div>
    ) : null
  }

  return (
    <>
      {(props.isOrdered ? props.populations : sortBy(props.populations, "name")).map((population, i) => (
        <div key={i} className={className} onClick={click}>
          <FontAwesomeIcon icon={faCaretRight} />
          &nbsp;
          {population.filterName && <span>{population.filterName} : </span>}
          <b>{population.name}</b>
        </div>
      ))}
    </>
  )
}
